import hotTopic from "../images/hot-topic.jpeg";
import interviewTopic from "../images/interview-topic.jpeg";
import stringMethod from "../images/string-method.png";

const blogsData = [
	{
		title: "10 JavaScript String Methods",
		img: stringMethod,
		link: "https://tamim-hossain.medium.com/10-javascript-string-methods-d4c7a6509694",
	},
	{
		title: "JavaScript Hot Topics",
		img: hotTopic,
		link: "https://tamim-hossain.medium.com/javascript-topics-72d1f077fe65",
	},
	{
		title: "10 JavaScript Interview Topics",
		img: interviewTopic,
		link: "https://tamim-hossain.medium.com/10-javascript-interview-topics-f58b2b77f937",
	},
];

export default blogsData;
